import React, { Component } from "react"
import Select from "react-select"
import "./FindField.css"

interface FieldFinderProps {
    isDropdown: boolean
    tagName: string
}

type FieldFinderTypes = {
    input: string
    fields: Array<{ text: string, elem: any }>
}

class FieldFinder extends Component<FieldFinderProps, FieldFinderTypes> {

    interval: any

    state = {
        input: "",
        fields: []
    }

    componentDidMount() {
        this.interval = setInterval(this.populate, 500)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }
    //removes FoundField class
    purge = () => {
        let elems = document.getElementsByClassName("FoundField")
        for (let i = 0; i < elems.length; i++) {
            elems[i].setAttribute("class", "FindField")
        }
    }

    populate = () => {
        let temp: Array<{ text: string, elem: any }> = []
        let elems = document.getElementsByClassName("FindField")
        for (let i = 0; i < elems.length; i++) {
            let elem = elems[i]
            let text = elems[i].getElementsByTagName(this.props.tagName)[0].innerHTML.split("<")[0]
            // //console.log("elem: ", elem)
            // //console.log("text: ", text)
            temp.push({ text: text, elem: elem })
        }

        if (this.isChanged(temp)) {
            this.setState({ fields: temp })
        }
    }

    //this checks if any of the elements have changed (user switched tabs or something)
    isChanged = (fields: Array<{ text: string, elem: any }>) => {
        let a = this.state.fields
        let b = fields
        if (a.length !== b.length) {
            return true
        } else if (a.length === 0) {
            return true
        } else {
            for (let i = 0; i < a.length; i++) {
                if (a[i] !== b[i]) {
                    return true
                }
            }
        }
        return false
    }

    scroll = (elem: any) => {
        this.purge()
        elem.setAttribute("class", "FoundField")
        this.openAccordion()
        setTimeout(() => {//wait for accordions to open
            elem.scrollIntoView({ block: "nearest" })
        }, 500);
    }

    openAccordion = () => {
        let elems = document.getElementsByTagName("*")
        for (let i = 0; i < elems.length; i++) {//loop through all elements
            if (elems[i].className === "FoundField") {//first find the element with the class named "FoundField"
                for (let j = i; j > 0; j--) {//loop backwards from that elements index in the class list
                    if ((elems[j].classList.contains("collapse")) && !(elems[j].classList.contains("show"))) {//check if any elements have the class "collapse" and not "show"
                        for (let k = j; k > 0; k--) {//loop backwards from that elements index in the class list
                            if (elems[k].className === "card-header") {//find the element that has the class card-header
                                const id = `card-header-${k}`//give it an id
                                elems[k].id = id
                                const elem = document.getElementById(id)
                                elem?.click()//click it
                                break
                            }
                        }
                        break
                    }
                }
                break
            }
        }
    }

    render() {

        return (
            <div className="FieldFinder">
                <div className="FieldFinderSearchBar">
                    {this.props.isDropdown && this.state.fields.length > 0 && <Select
                        placeholder={"Jump to field"}
                        options={this.state.fields.map((item: any) => ({ value: item.text, label: item.text, item: item }))}
                        onChange={(item: any) => {
                            this.scroll(item.item.elem)
                        }}
                        maxMenuHeight={175}
                    />}
                </div>
            </div>
        )
    }
}

export default FieldFinder